import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { refreshTokenEndPoint } from './endPoints';

export class TokenService {
  static getLocalRefreshToken() {
    return localStorage.getItem('refreshToken') + '';
  }
  static getLocalAccessToken() {
    return localStorage.getItem('accessToken') + '';
  }
  static updateLocalAccessToken(token: string) {
    localStorage.setItem('accessToken', token);
  }
  static removeAll() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  }
  static async forceRefresh(){
    const res = await axios.post(refreshTokenEndPoint, null, {
      headers: { 'X-Refresh-Token': TokenService.getLocalRefreshToken() },
    });
    const accessToken = res.data.access_token;
    if (!accessToken)
      throw new Error('No access token');
    TokenService.updateLocalAccessToken(accessToken);
    return true;

  }
}

export const interceptor = (instance: AxiosInstance) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let refreshing_token: null | Promise<AxiosResponse<any, any>> = null;
  const refresh_token = () => {
    return instance.post(refreshTokenEndPoint, null, {
      headers: { 'X-Refresh-Token': TokenService.getLocalRefreshToken() },
    });
  };

  instance.interceptors.request.use(
    (config) => {
      if (config.headers === undefined) {
        config.headers = {};
      }
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
  instance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      if (originalConfig.url !== '/auth/login' && err.response) {
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          try {
            refreshing_token = refreshing_token
              ? refreshing_token
              : refresh_token();
            const res = await refreshing_token;
            refreshing_token = null;
            const accessToken = res.data.access_token;
            if (!accessToken) throw new Error('No access token');
            TokenService.updateLocalAccessToken(accessToken);
            return instance(originalConfig);
          } catch (_error) {
            return Promise.reject(_error);
          }
        }
      }
      return Promise.reject(err);
    },
  );
};
